import { supabase } from '@/integrations/supabase/client';

const BASE = () => (import.meta.env.VITE_SUPABASE_URL as string) ?? 'https://beta.crm-api.primetecia.com.br/api';

export type StatusSessao = 'abrindo' | 'procurando' | 'falando' | 'esperando' | 'pausado' | 'encerrada';
export type StatusNumero = 'na_fila' | 'discando' | 'atendeu' | 'caixa_postal' | 'nao_atende' | 'ocupado' | 'invalido' | 'erro' | 'quarentena' | 'nao_e_daqui' | 'pulado';

export interface NumeroAutoDialer {
  id: string;
  telefone: string;
  rotulo: string | null;
  grupo: string | null;
  operadora: string | null;
  whatsapp: boolean | null;
  nao_perturbe: boolean;
  quarentena_ate: string | null;
  status: StatusNumero;
  resultado_em: string | null;
  rota?: string | null;
}

export interface EstadoAutoDialer {
  sessao: { id: string; status: StatusSessao; motivo: string | null; numero_atual: string | null; call_id: string | null; iniciada_em: string; encerrada_em: string | null };
  lead_atual: null | {
    lead_id: string; ordem: number; status: string; assertiva: string | null;
    razao_social?: string | null; tipo_lead?: string | null; tipo_pessoa?: string | null; top?: string | null; top_nome?: string | null;
    previa?: null | { fonte: string; hoje: { valor: number | null; resumo: string } | null; total_3m: number | null; total_depois: number | null; resumo_claro: string | null; pedir_conta: boolean };
    email?: null | { modelo: string | null; enviado_em: string | null; abriu: boolean; abriu_em: string | null; clicou_em: string | null };
  };
  placar_hoje?: { ligacoes: number; atenderam: number; caixa_postal: number; leads: number };
  lista?: { id: string; nome: string } | null;
  numeros: NumeroAutoDialer[];
  proximos: Array<{ lead_id: string; ordem: number; razao_social: string | null; tipo_lead: string | null; top: string | null; numeros: number }>;
  totais: { leads: number; feitos: number; falou: number; sem_contato: number };
}

async function chamar<T>(caminho: string, corpo?: unknown): Promise<T> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Sessão expirada — faça login novamente.');
  const r = await fetch(`${BASE()}/v1/auto-dialer/${caminho}`, {
    method: corpo === undefined ? 'GET' : 'POST',
    headers: { Authorization: `Bearer ${session.access_token}`, ...(corpo === undefined ? {} : { 'Content-Type': 'application/json' }) },
    body: corpo === undefined ? undefined : JSON.stringify(corpo),
  });
  const body = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(body?.error || 'O Auto Dialer não respondeu. Tente de novo.');
  return body.data as T;
}

export const buscarSessaoAutoDialer = () => chamar<EstadoAutoDialer | null>('sessao');
export interface ListaAutoDialer {
  id: string; nome: string; criada_em: string; atualizada_em: string;
  total: number; pendentes: number; falou: number; sem_contato: number; na_proxima_rodada: number;
  proxima_rodada_em: string | null; aberta: boolean;
}

export const iniciarAutoDialer = (leadIds: string[], nome?: string | null) =>
  chamar<{ sessao_id: string; lista_id: string; nome: string; leads: number; fora: number }>('iniciar', { lead_ids: leadIds, nome: nome || null });
export const retomarListaAutoDialer = (listaId: string) =>
  chamar<{ sessao_id: string; lista_id: string; nome: string; leads: number }>('retomar', { lista_id: listaId });
export const buscarListasAutoDialer = () => chamar<ListaAutoDialer[]>('listas');
export const ligarOutroNumeroAutoDialer = (telefone: string, leadId?: string | null) =>
  chamar<{ telefone: string; lead_id: string }>('ligar-outro', { telefone, lead_id: leadId || null });
export const pausarAutoDialer = () => chamar('pausar', {});
export const despausarAutoDialer = () => chamar('despausar', {});
export const proximoNumeroAutoDialer = () => chamar('proximo-numero', {});
export const proximoLeadAutoDialer = () => chamar('proximo-lead', {});
export const encerrarAutoDialer = () => chamar('encerrar', {});
export const naoEDaquiAutoDialer = (numeroId: string) => chamar('nao-e-daqui', { numero_id: numeroId });
export const contatoRealAutoDialer = (numeroId: string, nome: string, cargo: string | null) =>
  chamar('contato-real', { numero_id: numeroId, nome, cargo });
